module.exports = __webpack_public_path__ + "mainassets/img/rule_3.35d4d7ed.jpg";